import React, { Component } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import InjectedCheckoutForm from './InjectedCheckoutForm';

class CheckoutComponent extends Component {
	constructor(props) {
		super(props);

		this.handleStripeFormInit = this.handleStripeFormInit.bind(this);
		this.state = {
			stripeInstance: null
		};
	}

	componentDidMount() {
		const { paymentMethod: { configuration } } = this.props;
		const stripe = loadStripe(configuration.publishableApiKey, {
			stripeAccount: configuration.connectedAccountId   // perform calls on behalf of a connected Stripe account
		});
		this.setState({ stripeInstance: stripe });
	}

	handleStripeFormInit({ stripeSubmitHandle, stripePaymentHandle }) {
		this.props.onPaymentMethodInit(this.props.paymentMethod, { stripeSubmitHandle, stripePaymentHandle });
	}

	render() {
		const { payment, currency, countryCode, isInstalmentPayment, instalmentPlan, paymentMethod: { configuration } } = this.props;
		const hasDeposit = isInstalmentPayment ? (instalmentPlan && instalmentPlan.downPaymentAmount) || 0 > 0 : false;
		const mode = isInstalmentPayment && !hasDeposit ? 'setup' : 'payment';
		const amount = isInstalmentPayment && hasDeposit ? instalmentPlan.downPaymentAmount : payment.totalAmount;

		const options = {
			mode,
			currency: currency.toLowerCase(),
			amount: mode === 'payment' ? Math.round(amount * 100) : null,
			setupFutureUsage: isInstalmentPayment ? 'off_session' : undefined,
			payment_method_configuration: configuration.paymentMethodConfigurationId
		};

		return <div className='description' style={{ marginTop: '20px' }}>
			<Elements stripe={this.state.stripeInstance} options={options}>
				<InjectedCheckoutForm onInit={this.handleStripeFormInit} payment={payment} countryCode={countryCode} />
			</Elements>
		</div>;
	}
}

export default CheckoutComponent;